<template>
  <b-row>
    <b-col>
      <b-card
        header="Actions"
        header-tag="h4"
        header-bg-variant="white"
        class="my-3"
      >
        <b-button
          variant="outline-danger"
          size="md"
          @click.prevent="remove($route.params.id)"
        >Delete Campaign</b-button>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('campaigns', [
      'deleteCampaign'
    ]),

    remove(id) {
      if (confirm(`Are you sure you want to delete this campaign?`)) {
        this.deleteCampaign(id)
          .then(() => {
            this.$router.push({ name: 'campaigns-index' })
          })
      }
    }
  }
}
</script>
